import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2224f1c3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2224f1c3&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=2224f1c3&prod&lang=less"
import style2 from "./index.vue?vue&type=style&index=2&id=2224f1c3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2224f1c3",
  null
  
)

export default component.exports